import { render, staticRenderFns } from "./StatusSelect.vue?vue&type=template&id=0161cd8c&"
import script from "./StatusSelect.vue?vue&type=script&lang=js&"
export * from "./StatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports